var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 6V4C3 3.4477 3.4477 3 4 3H6C6.5523 3 7 3.4477 7 4V6C7 6.5522 6.5523 7 6 7H4C3.4477 7 3 6.5522 3 6ZM11 7H13C13.5523 7 14 6.5522 14 6V4C14 3.4477 13.5523 3 13 3H11C10.4477 3 10 3.4477 10 4V6C10 6.5522 10.4477 7 11 7ZM18 7H20C20.5523 7 21 6.5522 21 6V4C21 3.4477 20.5523 3 20 3H18C17.4477 3 17 3.4477 17 4V6C17 6.5522 17.4477 7 18 7ZM4 14H6C6.5523 14 7 13.5522 7 13V11C7 10.4477 6.5523 10 6 10H4C3.4477 10 3 10.4477 3 11V13C3 13.5522 3.4477 14 4 14ZM11 14H13C13.5523 14 14 13.5522 14 13V11C14 10.4477 13.5523 10 13 10H11C10.4477 10 10 10.4477 10 11V13C10 13.5522 10.4477 14 11 14ZM18 14H20C20.5523 14 21 13.5522 21 13V11C21 10.4477 20.5523 10 20 10H18C17.4477 10 17 10.4477 17 11V13C17 13.5522 17.4477 14 18 14ZM4 21H6C6.5523 21 7 20.5522 7 20V18C7 17.4477 6.5523 17 6 17H4C3.4477 17 3 17.4477 3 18V20C3 20.5522 3.4477 21 4 21ZM11 21H13C13.5523 21 14 20.5522 14 20V18C14 17.4477 13.5523 17 13 17H11C10.4477 17 10 17.4477 10 18V20C10 20.5522 10.4477 21 11 21ZM18 21H20C20.5523 21 21 20.5522 21 20V18C21 17.4477 20.5523 17 20 17H18C17.4477 17 17 17.4477 17 18V20C17 20.5522 17.4477 21 18 21Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.289cbc5cfd23f7c24dae1504b2e5f447.svg";
export { ForwardRef as ReactComponent };